import { IdNamePair, CpsLocale, DEFAULT_LOCALE } from '@cs-cms/types';
import { createContext, useContext } from 'react';

interface IGlobalizationContext {
  availableLocales?: IdNamePair[];
  selectedLocale: CpsLocale;
  setSelectedLocale?: (newLocale: CpsLocale) => void;
}

const defaultValue: IGlobalizationContext = {
  selectedLocale: DEFAULT_LOCALE
};

export const GlobalizationContext = createContext<IGlobalizationContext>(defaultValue);

export const useGlobalizationContext = () => useContext(GlobalizationContext);
